import React, { useEffect, useState } from 'react';

const UProgressBar = ({ color = 'blue', duration = 7000, style = {}, onComplete }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    let start = 0;
    const intervalTime = 50; // update every 50ms
    const increment = 100 / (duration / intervalTime);

    const interval = setInterval(() => {
      start += increment;
      if (start >= 100) {
        start = 100;
        clearInterval(interval);
        if (onComplete) onComplete();
      }
      setPercentage(Math.floor(start));
    }, intervalTime);

    return () => clearInterval(interval);
  }, [duration, onComplete]);

  return (
    <div className="u_flex-align u_content-center">
      <div className={`u_progress-bar`} style={style}>
        <span className={color} style={{ width: `${percentage}%` }} />
      </div>
      <span className="u_text-bold u_color-title u_small-font u_ml-12">
        {percentage}%
      </span>
    </div>
  );
};

export default UProgressBar;
